import { ProgramStoreSettings } from "src/app/infrastructure/models/program-store-settings";
import { GenericProgram } from "./models/generic-program";
import { GenericProgramStore } from "./stores/generic-program.store";
import { GenericProgramSettings } from "./generic-program-settings";

export const GenericProgramStoreSettings: ProgramStoreSettings<GenericProgram> = {
  storeType: GenericProgramStore,
  programSettings: GenericProgramSettings,
};
